import { render, staticRenderFns } from "./Navbarchat.vue?vue&type=template&id=16ca2b3c&"
import script from "./Navbarchat.vue?vue&type=script&lang=js&"
export * from "./Navbarchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports